import { useMemo } from 'react';
import { sortContactsByName, sortConversationsByRecentActivity } from '../utils/sorting';

/**
 * Custom hook to get sorted contacts
 * @param {Array} contacts - Array of contact objects
 * @returns {Array} - Memoized sorted contacts
 */
export const useSortedContacts = (contacts) => {
  return useMemo(() => sortContactsByName(contacts), [contacts]);
};

/**
 * Custom hook to get sorted conversations
 * @param {Array} conversations - Array of conversation objects  
 * @returns {Array} - Memoized sorted conversations
 */
export const useSortedConversations = (conversations) => {
  return useMemo(() => sortConversationsByRecentActivity(conversations), [conversations]);
};
